import { render, staticRenderFns } from "./knowledge_graph.vue?vue&type=template&id=3c10f59f&scoped=true"
import script from "./knowledge_graph.vue?vue&type=script&lang=js"
export * from "./knowledge_graph.vue?vue&type=script&lang=js"
import style0 from "./knowledge_graph.vue?vue&type=style&index=0&id=3c10f59f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10f59f",
  null
  
)

export default component.exports